export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (!config.public.loki.dsn) {
    return
  }
  const logLoki = async (level: string, data: unknown): Promise<void> => {
    if (config.public.appEnv !== 'development') {
      const logLine = JSON.stringify(data)
      $fetch(config.public.loki.dsn + '/push', {
        baseURL: config.public.loki.dsn,
        credentials: 'include',
        method: 'POST',
        headers: {
          'x-scope-orgid': 'tenant1',
        },
        body: {
          streams: [
            {
              stream: {
                level: level,
                app: 'magvi',
              },
              values: [
                [ Date.now() * 1000000 + '', logLine ],
              ],
            },
          ],
        },
      })
    }
  }

  const originalLog = window.console.log
  window.console.log = (...data: unknown[]) => {
    logLoki('info', data)
    originalLog(...data)
  }
  const originalError = window.console.error
  window.console.error = (...data: unknown[]) => {
    logLoki('error', data)
    originalError(...data)
  }
  const originalInfo = window.console.info
  window.console.info = (...data: unknown[]) => {
    logLoki('info', data)
    originalInfo(...data)
  }
  const originalWarn = window.console.warn
  window.console.warn = (...data: unknown[]) => {
    logLoki('warn', data)
    originalWarn(...data)
  }
})
